export enum UserPreferencesDomain {
  DeliverViews = 'deliver_views',
  AnalyticsViews = 'analytics_views',
}
